import { Component, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EventResponse, EventServiceResponse } from '../../../../../../../../@shared/models/response.module';
import { EventsService } from '../../../../../../../../@shared/services/events-service';
import { AddEventService } from '../../../manage-event/components/manage-event-service/components/add-event-service/add-event-service';
import { EditEventService } from '../../../manage-event/components/manage-event-service/components/edit-event-service/edit-event-service';
import { AQH_EVE_11 } from '../../../../../../../../@shared/models/input.module';

@Component({
  selector: 'app-wizard-step-services',
  standalone: false,
  templateUrl: './wizard-step-services.html',
  styleUrl: './wizard-step-services.css'
})
export class WizardStepServices {
  @Input() event: EventResponse | null = null;
  @Output() eventUpdated = new EventEmitter<EventResponse>();

  services: EventServiceResponse[] = [];
  private lastLoadedEventId: number | null = null;

  constructor(
    private modalService: NgbModal,
    private eventService: EventsService
  ) {}

  ngOnInit() {
    this.loadServices();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['event'] && this.event?.event_id && this.event.event_id !== this.lastLoadedEventId) {
      this.loadServices();
    }
  }

  loadServices() {
    if (!this.event?.event_id) return;

    this.lastLoadedEventId = this.event.event_id;
    const params: AQH_EVE_11 = { event_id: this.event.event_id };
    this.eventService.getEventServices(params).subscribe((services) => {
      this.services = services || [];
    });
  }

  openAddServiceModal() {
    if (!this.event) return;

    const modalRef = this.modalService.open(AddEventService, { size: 'lg', centered: true });
    modalRef.componentInstance.event = this.event;

    modalRef.result.then((result) => {
      if (result) {
        this.loadServices();
      }
    }).catch(() => {});
  }

  openEditServiceModal(service: EventServiceResponse) {
    if (!this.event) return;

    const modalRef = this.modalService.open(EditEventService, { size: 'lg', centered: true });
    modalRef.componentInstance.service = service;

    modalRef.result.then((result) => {
      if (result) {
        this.loadServices();
      }
    }).catch(() => {});
  }

  deleteService(service: EventServiceResponse) {
    if (!confirm(`Are you sure you want to delete "${service.event_service_name}"?`)) return;

    this.eventService.deleteEventService({
      event_service_id: service.event_service_id
    }).subscribe({
      next: () => {
        this.loadServices();
      }
    });
  }
}
